import { useEffect, useMemo, useState } from "react";
import { useGetExceptionScheduleQuery, useUpdateExceptionScheduleMutation } from "../../../../services/schedulers";
import { TSpecialEvent } from "../types";
import {  UpdateExceptionScheduleArgs } from "../../../../services/schedulers/types";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";
import { TSpecialEventExtensions } from "../typeExtensions/TSpecialEventExtensions";


function useExceptionSchedule(objectId: string, resourceGroupId: string): {
    exceptionSchedule: TSpecialEvent[],
    hasChanges: boolean,
    isSaving: boolean,
    isLoading: boolean,
    isSuccess: boolean,
    error: any,
    add: (item: TSpecialEvent) => void,
    update: (item: TSpecialEvent) => void,
    remove: (item: TSpecialEvent) => void
    save: () => void
} {

    const { data, isSuccess, isLoading, error } = useGetExceptionScheduleQuery({ resourceGroupId: resourceGroupId, objectId: objectId });
    const [update, upateResult] = useUpdateExceptionScheduleMutation();
    useReportMutationState(upateResult, () => { setChanged(false); });

    const [exceptionSchedule, setExceptionSchedule] = useState<TSpecialEvent[]>([])
    const [changed, setChanged] = useState(false);

    useEffect(() => {
        const entries = TSpecialEventExtensions.fromDtos(data ?? []);
        setExceptionSchedule(entries ?? []);
    }, [data]);


    const handleAdd = (item: TSpecialEvent) => {
        const tmp = [...exceptionSchedule];
        tmp.push(item);
        setExceptionSchedule(tmp);
        setChanged(true);
    }
    const handleUpdate = (item: TSpecialEvent) => {
        const tmp = [...exceptionSchedule];
        const entryIndex = tmp.indexOf(item);
        tmp[entryIndex] = item;
        setExceptionSchedule(tmp);
        setChanged(true);
    }

    const handleDelete = (item: TSpecialEvent) => {
        const tmp = [...exceptionSchedule];
        const entryIndex = tmp.indexOf(item);
        tmp.splice(entryIndex, 1);
        setExceptionSchedule(tmp);
        setChanged(true);
    }
    const handleApplyChanges = () => {
        const newval = TSpecialEventExtensions.toDtos(exceptionSchedule);
        const cmd: UpdateExceptionScheduleArgs = {
            resourceGroupId: resourceGroupId,
            objectId: objectId,
            body: newval
        }
        update(cmd);
    }
    return {
        exceptionSchedule: exceptionSchedule,
        hasChanges: changed,
        save: handleApplyChanges,
        isSaving: upateResult.isLoading,
        add: handleAdd,
        update: handleUpdate,
        remove: handleDelete,
        isLoading: isLoading,
        error: error,
        isSuccess: isSuccess
    }
}

export default useExceptionSchedule;



